/**
 * Shared API client utilities
 *
 * Auth strategy:
 * - Clerk users: session cookie is sent automatically (same-origin),
 *   no Authorization header needed.
 * - Local JWT users (password login): Bearer token from localStorage.
 */

export const API_BASE = '/api';

// When true, Clerk cookies handle auth — don't send a Bearer token.
let _useClerkCookieAuth = false;

export function setUseClerkCookieAuth(enabled: boolean) {
  _useClerkCookieAuth = enabled;
}

export function getAuthHeaders(): Record<string, string> {
  // Clerk same-origin: cookie is automatic, no header needed
  if (_useClerkCookieAuth) return {};

  // Local JWT auth: send Bearer token
  const token = localStorage.getItem('auth_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function fetchJson<T>(url: string, options?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${url}`, {
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders(), ...options?.headers },
    ...options,
  });
  if (!res.ok) {
    const error = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(error.error || res.statusText);
  }
  return res.json();
}
